import React from "react";
import { RandomReveal } from "react-random-reveal";
import { BubbleButton } from "../BubbleButton";

import "./ShowBoat.scss";
import copy from "./copy.svg";

export type ShowBoatProps = {
  text?: string;
};

/**
 * Shows a password in a cool flippy display. Implements react-reel.
 */
export const ShowBoat: React.FC<ShowBoatProps> = ({ text }) => {
  const addToClipboard = async (value: string) => {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        console.log("copied");
      })
      .catch((err) => {
        console.error("Could not copy. " + err);
      });
  };

  return (
    <div className="showboat-container">
      <div className="showboat">
        <div className="password-display">
          {text && (
            <RandomReveal
              isPlaying
              key={text} // This keeps react from thinking it's the same component with different text.
              duration={2}
              characters={text}
            />
          )}
        </div>
        <div className="copy-button-container">
          <BubbleButton
            className="copy-button"
            color="pop"
            onClick={() => text && addToClipboard(text)}
          >
            <span role="img" aria-label="clipboard">
              <img
                src={copy}
                alt="copy"
                style={{
                  width: "1.5em",
                  height: "1.5em",
                  marginBottom: "-0.4em",
                }}
              />
            </span>
            Copy
          </BubbleButton>
        </div>
      </div>
    </div>
  );
};
